import * as React from 'react';
import { map } from 'lodash';
import classNames from 'classnames';

import { modes } from '@comall-backend-builder/types';
import { UploadFile, ImagePreview } from '@comall-backend-builder/components-basis';

export class ImageObjectArrayMode extends modes.ArrayMode {
    /**
     * 获取展示组件
     */
    public getDisplayComponent(array: any, displayInfo: any) {
        const { className, style, preview } = displayInfo;

        if (array && array.length) {
            // 原数据集array需要格式化，在preview中显示
            let formatArray: Array<any> = [];
            map(array, (item, key) => {
                formatArray.push({
                    id: key,
                    imageurl: item,
                    text: item,
                    component: 'Image',
                });
            });

            // 图片配置信息
            const imageConfig = {
                className: classNames('type-array mode-array-images', className),
                style,
            };

            // 预览组件配置信息
            const previewProps = {
                ...preview,
                type: 'modal',
                imageConfig,
                items: formatArray,
            };

            return <ImagePreview {...previewProps} />;
        } else {
            return super.getNotAvailableDisplayComponent(displayInfo);
        }
    }

    /**
     * 获取输入组件
     */
    public getControlComponent(controlInfo: any) {
        let _controlInfo = Object.assign({}, controlInfo, {
            accept: controlInfo.accept ? controlInfo.accept : 'image/*',
            uploadType: 'multi',
        });
        return <UploadFile {..._controlInfo} />;
    }
}
